import { useEffect, useState } from 'react';

import { api } from 'services/api';
import { Country } from '../models/country';

interface ProviderServerApi {
  id: number;
  country: string;
  countryName: string;
}

export function useCountries(): Country[] {
  const [countries, setCountries] = useState<Country[]>([]);

  useEffect(() => {
    api
      .get<{ data: ProviderServerApi[] }>('/admin/provider-servers')
      .then(({ data }) => {
        setCountries(
          data
            .map(item => ({
              code: item.country || '',
              name: item.countryName || ''
            }))
            .filter(item => item.name && item.code)
        );
      })
      .catch(err => Promise.reject(err.message));
  }, []);

  return countries;
}
